import { ApiEnvironment } from '../../models/api-environment';

export class FleetEnvironment extends ApiEnvironment {
  routingProfileVehicleGroupsUrl(routingProfileId: number) {
    return `${this.baseUrl}/routingProfile/${routingProfileId}/vehicleGroups`;
  }

  get avoidFavorSetsUrl() {
    return `${this.baseUrl}/avoidFavorSets`;
  }

  avoidFavorSetsDefaultUrl(setId: number, isDefault: boolean) {
    return `${this.baseUrl}/avoidFavorSets/${setId}/default/${isDefault}`;
  }

  avoidFavorSetsVehicleGroupsUrl(setId: number) {
    return `${this.baseUrl}/avoidFavorSets/${setId}/vehicleGroups`;
  }

  avoidFavorSetsVehicleGroupsCombinedAssignmentUrl(setId: number) {
    return `${this.baseUrl}/avoidFavorSets/${setId}/vehicleGroups/combinedassignment`;
  }

  get configurationProfilesUrl() {
    return `${this.baseUrl}/configurationProfiles`;
  }

  configurationProfilesDefaultUrl(profileId: number, isDefault: boolean) {
    return `${this.baseUrl}/configurationProfiles/${profileId}/default/${isDefault}`;
  }

  configurationProfilesVehicleGroupsUrl(id: number) {
    return `${this.baseUrl}/configurationProfiles/${id}/vehicleGroups`;
  }

  configurationProfilesVehicleGroupsCombinedAssignmentUrl(id: number) {
    return `${this.baseUrl}/configurationProfiles/${id}/vehicleGroups/combinedassignment`;
  }

  get mapSetsUrl() {
    return `${this.baseUrl}/mapSets`;
  }

  mapSetsIdUrl(id: number) {
    return `${this.baseUrl}/mapSets/${id}`;
  }

  get companyMapsetSettingsUrl() {
    return `${this.baseUrl}/company/mapsetSettings`;
  }

  mapSetsVehicleGroupsUrl(id: number) {
    return `${this.baseUrl}/mapSets/${id}/vehicleGroups/`;
  }

  mapSetsVehicleGroupsAssignUrl(id: number) {
    return `${this.baseUrl}/mapSets/${id}/vehicleGroups/assign`;
  }

  mapSetsVehicleGroupsUnassignUrl(id: number) {
    return `${this.baseUrl}/mapSets/${id}/vehicleGroups/unassign`;
  }

  mapSetsVehicleGroupsAssignmentUrl(id: number) {
    return `${this.baseUrl}/mapSets/${id}/vehicleGroups/assignment`;
  }

  get placeSetsUrl() {
    return `${this.baseUrl}/placeSets`;
  }

  placeSetsDefaultUrl(placeSet: number, isDefault: boolean) {
    return `${this.baseUrl}/placeSets/${placeSet}/default/${isDefault}`;
  }

  placeSetsVehicleGroupsUrl(setId: number) {
    return `${this.baseUrl}/placeSets/${setId}/vehicleGroups`;
  }

  placeSetsVehicleGroupsCombinedAssignmentUrl(setId: number) {
    return `${this.baseUrl}/placeSets/${setId}/vehicleGroups/combinedassignment`;
  }

  get vehiclesUrl() {
    return `${this.baseUrl}/vehicles`;
  }

  get vehicleGroupsUrl() {
    return `${this.baseUrl}/vehicleGroups`;
  }

  vehicleGroupsIdUrl(vehicleGroupId: string) {
    return `${this.baseUrl}/vehicleGroups/${vehicleGroupId}`;
  }

  vehicleGroupsVehiclesUrl(vehicleGroupId: string) {
    return `${this.baseUrl}/vehicleGroups/${vehicleGroupId}/vehicles`;
  }

  vehicleGroupsVehiclesCombinedAssignmentUrl(vehicleGroupId: string) {
    return `${this.baseUrl}/vehicleGroups/${vehicleGroupId}/vehicles/combinedAssignment`;
  }

  vehicleGroupsRoutingProfilesUrl(vehicleGroupId: string) {
    return `${this.baseUrl}/vehicleGroups/${vehicleGroupId}/routingProfiles`;
  }

  vehicleGroupsRoutingProfilesCombinedAssignmentUrl(vehicleGroupId: string) {
    return `${this.baseUrl}/vehicleGroups/${vehicleGroupId}/routingProfiles/combinedAssignment`;
  }

  get webAuthenticateUrl() {
    return `${this.baseUrl}/accounts/webAuthenticate`;
  }

  get driversUrl() {
    return `${this.baseUrl}/drivers`;
  }

  get driverGroupsUrl() {
    return `${this.baseUrl}/driverGroups`;
  }

  driverGroupsIdUrl(driverGroupId: string) {
    return `${this.baseUrl}/driverGroups/${driverGroupId}`;
  }

  get driverListUrl() {
    return `${this.baseUrl}/driverlist`;
  }

  driverGroupsDriversAssignUrl(driverGroupId: string) {
    return `${this.baseUrl}/driverGroups/${driverGroupId}/drivers/assign`;
  }

  driverGroupsDriversUnassignUrl(driverGroupId: string) {
    return `${this.baseUrl}/driverGroups/${driverGroupId}/drivers/unassign`;
  }
}

export const fleetEnvironment = new FleetEnvironment();
